import styled from "styled-components";

interface IActionCardProps {
  color?: string;
  title?: string;
  count?: string;
  rate?: string;
}

const ActionCard: React.FC<IActionCardProps> = (props) => {
  return (
    <Wrapper>
      <div className="w-100 wrapper" style={{ backgroundColor: `${props.color}` }}>
        <span className="title">{props.title}</span>
        <span className="number">{props.count}</span>
        <span className="rate">{props.rate}</span>
      </div>
    </Wrapper>
  );
};

export default ActionCard;

ActionCard.defaultProps = {
  color: "#FF9531",
  title: "Opens",
  count: "000",
  rate: "75% open rate",
};

const Wrapper = styled.div`
  .wrapper {
    border-radius: 6px;
    padding: 6px 10px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 4px;
    }
    span {
      color: #ffffff;
      font-weight: 400;
      font-family: "Roboto Slab", serif;
      display: block;
    }
    .title {
      text-align: center;
      font-size: 12px;
      margin-bottom: 15px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 9px;
        margin-bottom: 10px;
      }
    }
    .number {
      text-align: center;
      font-size: 30px;
      line-height: 12px;
      margin-bottom: 15px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 22px;
        margin-bottom: 12px;
        line-height: 8px;
      }
    }
    .rate {
      text-align: center;
      font-size: 10px;
      opacity: 0.75;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 7px;
      }
    }
  }
`;
